import React from 'react';
import { Breadcrumbs } from './Breadcrumbs';
import './PageHeader.css';

/**
 * PageHeader — шапка страницы (аудит U11).
 *
 *   title        — заголовок (клиент + короткий номер, а не служебный номер)
 *   subtitle     — одна строка пояснения (старое имя description тоже работает)
 *   breadcrumbs  — [{ label, path? }] (как у Breadcrumbs) или готовый элемент
 *   icon         — иконка lucide перед заголовком (на ТСД прячется)
 *   meta         — мелко справа от заголовка: «обновлено 5 мин назад», статус
 *   actions      — кнопки справа: до одной primary, остальное secondary/ghost
 *   children     — строка под шапкой (вкладки раздела)
 *
 * Мобильная кнопка меню (Layout.css, фиксирована слева сверху) на ТСД (body.tsd)
 * стоит поверх контента — строка с заголовком сдвигается вправо на 56 px, а
 * кнопки действий под ней остаются во всю ширину.
 */
export function PageHeader({
  title,
  subtitle,
  description,
  breadcrumbs,
  icon: Icon,
  meta,
  actions,
  children,
  className = '',
}) {
  const sub = subtitle ?? description;
  return (
    <header className={`ui-page-header ${children ? 'ui-page-header--with-sub' : ''} ${className}`}>
      <div className="ui-page-header__row">
        <div className="ui-page-header__main">
          {breadcrumbs && (Array.isArray(breadcrumbs)
            ? <Breadcrumbs items={breadcrumbs} className="ui-page-header__crumbs" />
            : <div className="ui-page-header__crumbs">{breadcrumbs}</div>)}
          <div className="ui-page-header__title-row">
            {Icon && <Icon size={22} className="ui-page-header__icon tsd-title-icon" aria-hidden="true" />}
            <h2 className="ui-page-header__title">{title}</h2>
            {meta && <span className="ui-page-header__meta">{meta}</span>}
          </div>
          {sub && <p className="ui-page-header__desc">{sub}</p>}
        </div>
        {actions && <div className="ui-page-header__actions">{actions}</div>}
      </div>
      {children && <div className="ui-page-header__sub">{children}</div>}
    </header>
  );
}
